import { render, staticRenderFns } from "./TelefonesForm.vue?vue&type=template&id=436a3122&scoped=true"
import script from "./TelefonesForm.vue?vue&type=script&lang=js"
export * from "./TelefonesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a3122",
  null
  
)

export default component.exports